import { render, staticRenderFns } from "./headMenu2.vue?vue&type=template&id=21062864&scoped=true"
import script from "./headMenu2.vue?vue&type=script&lang=js"
export * from "./headMenu2.vue?vue&type=script&lang=js"
import style0 from "./headMenu2.vue?vue&type=style&index=0&id=21062864&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21062864",
  null
  
)

export default component.exports